var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.82839 0.514842C10.0887 0.254492 10.5108 0.254494 10.7712 0.514842L12.1855 1.92905L14.0711 3.81467L15.4852 5.22888C15.7456 5.48924 15.7456 5.91135 15.4852 6.17169C15.2249 6.43204 14.8028 6.43204 14.5424 6.17169L13.6717 5.30101L8.82303 11.766L10.2998 13.2427C10.5601 13.5031 10.5601 13.9253 10.2998 14.1855C10.0395 14.4459 9.61733 14.4459 9.35699 14.1855L7.47137 12.3L6.05716 10.8857L1.69667 15.2462C1.43632 15.5066 1.0142 15.5066 0.753854 15.2462C0.493507 14.9859 0.493507 14.5638 0.753854 14.3034L5.11435 9.94293L3.70013 8.52872L1.81452 6.64309C1.55417 6.38275 1.55416 5.96064 1.81452 5.70029C2.07487 5.43995 2.49697 5.43995 2.75732 5.70029L4.23409 7.17707L10.6991 2.32833L9.82839 1.45765C9.56804 1.19731 9.56804 0.775188 9.82839 0.514842Z",
    fill: "#09a75e"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.4472d27016c3fd9cccd4c1d81d513f5f.svg";
export { ForwardRef as ReactComponent };